import React, { useState, useEffect } from 'react';
import Header from "../components/Header";
import Hero from "../components/LandingPage/Sections/Hero";
import Popular from "../components/LandingPage/Sections/Popular";
import Categories from "../components/LandingPage/Sections/Categories";
import Plans from "../components/LandingPage/Sections/Plans";
import FAQ from "../components/LandingPage/Sections/FAQ";
import Footer from "../components/Footer";
import ".././styles/style.scss";
import { getIp } from "../api/geoip/getIp";
import { getLocation } from "../api/geoip/getLocation";
//import { getSvodProducts } from '../api/product/getSvodProducts';
import { sendAnalyticsEvent } from '../utils/SendAnalyticsEvent';

function LandingPage() {
    const [pricing, setPricing] = useState({});
    const [country, setCountry] = useState("XX");
    useEffect(() => {
        sendAnalyticsEvent("discoverPageRender", {}, "Purchase Journey", "Discover page")
        const fetchData = async () => {
            const ip = await getIp();
            if (ip) {
                console.log(ip);
                const loc = await getLocation(ip);
                if (loc?.statusCode === "1") {
                    console.log(loc.data?.country?.isoCode);
                    setCountry(loc.data?.country?.isoCode)
                    if (process.env.REACT_APP_DISPLAY_PRICING_COUNTRIES.indexOf(loc.data?.country?.isoCode) >= 0) {
                        // const params = {
                        //     productCategory: "NPP",
                        //     includePromotions: true,
                        //     includeAppChannels: false,
                        //     includeFreemium: false,
                        //     country: loc.data.country.isoCode,
                        //     includeFutureProducts: false
                        // }
                        // const products = await getSvodProducts(params);
                        // if (products.length > 0) {
                        //     const standardMonthly = products.find(p => p.sku === process.env.REACT_APP_SKU_STANDARD_MONTHLY);
                        //     const standardAnnual = products.find(p => p.sku === process.env.REACT_APP_SKU_STANDARD_ANNUAL);
                        //     const premiumMonthly = products.find(p => p.sku === process.env.REACT_APP_SKU_PREMIUM_MONTHLY)
                        //     const premiumAnnual = products.find(p => p.sku === process.env.REACT_APP_SKU_PREMIUM_ANNUAL);
                        //     setPricing({
                        //         standard: {
                        //             monthly: standardMonthly?.currencyCode + " " + standardMonthly?.retailPrice,
                        //             annual: standardAnnual?.currencyCode + " " + standardAnnual?.retailPrice
                        //         },
                        //         premium: {
                        //             monthly: premiumMonthly?.currencyCode + " " + premiumMonthly?.retailPrice,
                        //             annual: premiumAnnual?.currencyCode + " " + premiumAnnual?.retailPrice
                        //         }
                        //     });
                        // }
                        if (loc.data?.country?.isoCode?.toUpperCase() === "US") {
                            setPricing({
                                standard: {
                                    monthly: "USD 4.99",
                                    annual: "USD 43.99"
                                },
                                premium: {
                                    monthly: "USD 12.99",
                                    annual: "USD 115.99"
                                }
                            });
                        } else if (loc.data?.country?.isoCode?.toUpperCase() === "CA") {
                            setPricing({
                                standard: {
                                    monthly: "CAD 6.99",
                                    annual: "CAD 62.99"
                                },
                                premium: {
                                    monthly: "CAD 9.99",
                                    annual: "CAD 89.90"
                                }
                            });
                        }
                    }
                }
            }
        }
        fetchData();
    }, []);

    return (
        <div>
            <Header isHomepage={true} />
            <Hero pricing={pricing} />
            <Popular />
            <Categories />
            <Plans pricing={pricing} country={country} />
            <FAQ />
            <Footer />
        </div>
    );
}

export default LandingPage;